import type { GridItem, ImageObject, Text, TextBlock } from '$lib/sanity/schemas';

export const extractAspectRatioFromAsset = (image: ImageObject) => {
  if (typeof image.asset !== 'string' && 'metadata' in image.asset) {
    return image.asset.metadata?.dimensions.aspectRatio;
  }
};

export const gridItemsToText = (gridItems: GridItem[]) => {
  return gridItems
    .map((gridItem) => {
      if (gridItem.componentType === 'portableText') {
        const text = gridItem.component as Text;
        return text?.body ? blocksToText(text.body) : '';
      }
      return '';
    })
    .join('\n\n');
};

export const blocksToText = (blocks: TextBlock[]) => {
  return blocks
    .map((block) => {
      if (block._type !== 'block' || !block.children) {
        return '';
      }

      return block.children ? block.children.map((child) => child.text).join('') : '';
    })
    .join('\n\n');
};
